import React, { Component } from 'react';
import SideBar from '../SideBar/SideBar';
import '../TicketBooking/TicketBooking.css'
import { toast } from 'react-toastify';
import Loader from '../Components/Utils/AnLoader/Loader'
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from "../Constant/axios"
export default class AirlineMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            PartyMasterData: [],
            serialNo: 1,
            selectedRowToEdit: []

        };

    }

    componentDidMount() {
        // var login = localStorage.getItem("token")
        // if (login === null || login === undefined) window.location.href = "/";
        this.getPartyDetail();

    }

    componentWillUnmount() {
       
    }
    getPartyDetail = () => {
        debugger
        axios.get(`/getPartyDetail`).then((res) => {
            if (res && res.data && res.data.data) {
                res.data.data.forEach(e => {
                    e.isDisabled = true
                });
                this.setState({ PartyMasterData: res.data.data, loading: false, });
            } else {
                this.setState({ PartyMasterData: [], loading: false, });
            }
        },
            (err) => {
                console.log(err);
            }
        );
    }


    handleCityName = (cell, val,name) => {
        debugger
        this.setState(prevState => ({
            PartyMasterData: prevState.PartyMasterData.map(item => {
                if (item.srno && item.srno === cell.srno) {
                    return {
                        ...item,
                        [name]: val, // Use computed property name to update dynamically
                        cr_by: this.state.userId,
                        isUpdated: true
                    };
                }
                return item;
            })
        }));
    }

    HandleAddNewRow = () => {
        let PartyMasterData = this.state.PartyMasterData
        let newJob = {
            temp_id: PartyMasterData.length + 1,
            srno: PartyMasterData.length + 1,
            party_name : "",
            party_code : "",
            party_pan : "",
            party_GST_no : "",
            party_contact_number : "",
            party_email : "",
            party_address : "",
            party_city : "",
            party_state : "",
            party_pincode : "",
        }
        PartyMasterData.unshift(newJob)
        this.setState({ PartyMasterData })
    }


    handledit = (cell, e) => {
        this.setState({ selectedRowToEdit: [] })

        var selectedRowToEdit = this.state.selectedRowToEdit
        selectedRowToEdit.push(cell)
        this.setState({ selectedRowToEdit })

        this.state.selectedRowToEdit.forEach(e => {
            e.isDisabled = false
        });
    }

    handleDeleteRecord = (cell) => {
        var TicketData = []

        var selectedRow = {
            Srno: cell.srno,
            id: cell.id,
            del_by: this.state.userId,
            isUpdated: true
        }
        TicketData.push(selectedRow)

        let masterData = {
            data: TicketData
        }

        Swal.fire({
            title: 'Are you sure you want to delete?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DB4444',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                const options = this.state.PartyMasterData.filter((item) => {
                    return item.srno !== cell.srno
                })


                this.setState({ PartyMasterData: options })
                Swal.fire(
                    'Deleted!',
                    'Your Data has been Deleted.',
                    'success'
                )

            } else {

            }
        }).catch((error) => {
            // Handle error
        });
    }

    handleDataSave = () => {
        debugger
        var PartyMasterData = [];
        for (var i = 0; i < this.state.PartyMasterData.length; i++) {

            if (this.state.PartyMasterData[i].isUpdated === true) {
                if (this.state.PartyMasterData[i].city_name === "" || this.state.PartyMasterData[i].city_name === "") {
                    toast.error(`Please fill in input fields in Row No. ${this.state.PartyMasterData[i].srno}`)
                    return false;
                }

                PartyMasterData.push(this.state.PartyMasterData[i])
            }
        }
        if (PartyMasterData.length > 0) {
            PartyMasterData = { data: PartyMasterData }

            this.setState({ loading: true })

            axios.post(`/savePartyDetail`, PartyMasterData).then((res) => {
                if(res.data.success === "success"){
                
                Swal.fire({
                    icon: "success",
                    title: "Your data has been saved in below table",
                    showConfirmButton: false,
                    timer: 2000
                });
                this.getPartyDetail()
            }
            })
        }
        else {
            Swal.fire({
                icon: "error",
                title: "No any new data in above table",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }
    render() {

        return (
            // this.state.loading ? <Loader /> :
            <div className="container-fluid">
                <div className="row mt-2">
                    <div className="col-md-2">
                        <SideBar ScreenName={"Party Master"} />
                    </div>
                    <div className="col-md-10">
                        <div className="container h-100 poDetailsContainer_media" style={{ marginTop: "73px", backgroundColor: "#f9fbfd", width: "96%", marginLeft: "34px" }}>
                            <div className="row m-0 p-0 align-items-center justify-content-center mb-3">
                                <div className="col-md-8 mt-3">
                                    <h4 className='FontB'><b>Party Master</b></h4>
                                </div>
                                <div className="col-md-4 mt-2 m-0 p-0 text-end mt-3">
                                    <button onClick={() => this.HandleAddNewRow()} className="btn-sm  buttonBorder me-2" style={{ cursor: "pointer" }}>Add New Row</button>

                                    {/* </div>
                                    <div className="col-md-2  mt-3"> */}
                                    <button type="submit" onClick={() => this.handleDataSave()} className="btn-sm buttonBorder2G" style={{ cursor: "pointer", color: 'white' }}>Save</button>

                                </div>

                            </div>

                            <div class="table-responsive">
                                {this.state.loading ? <Loader /> :
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className='thBg' scope="col" >Sr No </th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>Party Name</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>Party Code</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>PAN No</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>GSTN No</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>Contact No</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>Email No</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>Address</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>City</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>State</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "250px", textAlign: "center" }}>PIN Code</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Operations</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.PartyMasterData.map((item, index) => (
                                                <tr key={item.line_id}>
                                                    <td style={{ textAlign: "center" }}> {index + 1}</td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_name" value={item.party_name} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_code" value={item.party_code} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_pan" value={item.party_pan} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_GST_no" value={item.party_GST_no} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_contact_number" value={item.party_contact_number} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_email" value={item.party_email} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_address" value={item.party_address} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_city" value={item.party_city} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_state" value={item.party_state} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name="party_pincode" value={item.party_pincode} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>

                                                    <td style={{ textAlign: "center" }}>
                                                        <FontAwesomeIcon
                                                            icon={faEdit}
                                                            onClick={(e) => this.handledit(item, index, e)}
                                                            style={{ color: "#227446", fontSize: "18px", paddingRight: '9px', cursor: 'pointer' }}
                                                        />
                                                        {item.temp_id &&
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                onClick={(e) => this.handleDeleteRecord(item, index, e)}
                                                                style={{ cursor: 'pointer', color: "red", borderleft: '1px solid black', paddingleft: '9px', fontSize: "18px", marginLeft: '10px' }}
                                                            />
                                                        }
                                                    </td>

                                                </tr>
                                            ))}
                                            {(this.state.PartyMasterData.length === 0 &&
                                                <td colSpan={4} style={{ fontFamily: "poppins", textAlign: "center" }}> No Data Present</td>
                                            )}
                                        </tbody>

                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

